import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { Calendar, TrendingUp } from 'lucide-react';
import { Button } from '../ui/button';

export function UpcomingSessionCard({ bookings }) {
  const { t } = useLanguage();
  const upcomingBooking = bookings.find(b => new Date(b.date) >= new Date());

  return (
    <div className="bg-[#141417] border border-[#27272A] rounded-md p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-white" style={{ fontFamily: 'Chivo, sans-serif' }}>
          {t('dashboard.upcomingSessions')}
        </h2>
        <Link to="/dashboard/consulting">
          <Button variant="ghost" className="text-[#007AFF] text-sm">{t('dashboard.bookSession')}</Button>
        </Link>
      </div>

      {upcomingBooking ? (
        <div className="bg-[#007AFF]/10 border border-[#007AFF]/30 rounded-md p-4">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-[#007AFF] rounded-md flex items-center justify-center">
              <Calendar className="w-6 h-6 text-white" />
            </div>
            <div>
              <h3 className="text-white font-medium">{upcomingBooking.topic}</h3>
              <p className="text-[#71717A] text-sm">
                {new Date(upcomingBooking.date).toLocaleDateString()} at {upcomingBooking.time_slot}
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="text-center py-8">
          <Calendar className="w-12 h-12 text-[#71717A] mx-auto mb-4" />
          <p className="text-[#71717A] mb-4">{t('dashboard.noUpcomingSessions')}</p>
          <Link to="/dashboard/consulting">
            <Button className="btn-primary" data-testid="book-session-btn">{t('dashboard.bookSession')}</Button>
          </Link>
        </div>
      )}

      {/* Quick Actions */}
      <div className="mt-6 pt-6 border-t border-[#27272A]">
        <h3 className="text-white font-medium mb-4">{t('dashboard.quickActions')}</h3>
        <div className="grid grid-cols-2 gap-3">
          <Link to="/analysis">
            <Button variant="outline" className="w-full border-[#27272A] text-[#A1A1AA] hover:text-white" data-testid="quick-analysis">
              <TrendingUp className="w-4 h-4 mr-2" /> {t('nav.analysis')}
            </Button>
          </Link>
          <Link to="/dashboard/resources">
            <Button variant="outline" className="w-full border-[#27272A] text-[#A1A1AA] hover:text-white" data-testid="quick-resources">
              {t('dashboard.resources')}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
